import e from "../style.module.css";
import { Link } from "wouter";

interface links_types {
  url: string;
  name: string;
}

const links: links_types[] = [
  {
    url: "terminos-y-condiciones",
    name: "Terminos y condiciones",
  },
  {
    url: "politicas-de-cookies",
    name: "Políticas de cookies",
  },
];

export const NavbarFooter = () => {
  return (
    <ul className={e.nav__footer}>
      {links.map((ele, i) => (
        <li key={"url" + i}>
          <Link to={ele.url} className={e.navbar__line}>
            {ele.name}
          </Link>
        </li>
      ))}
    </ul>
  );
};
